import React from 'react';
import { useAuth } from '../context/AuthContext';
import { AlertOctagon, Mail, LogOut } from 'lucide-react';
import { Button } from './ui/button';

const AccessRestrictedScreen = () => {
  const { user, logout } = useAuth();

  return (
    <div
      className="fixed inset-0 z-[9999] bg-gradient-to-br from-red-900 via-red-800 to-red-950 flex items-center justify-center p-4 overflow-y-auto"
      data-testid="access-restricted-screen"
    >
      <div className="max-w-xl w-full bg-white rounded-2xl shadow-2xl overflow-hidden">
        {/* Top banner */}
        <div className="bg-red-600 text-white p-6 flex items-center gap-4">
          <div className="bg-white/20 rounded-full p-3 shrink-0">
            <AlertOctagon className="h-10 w-10" />
          </div>
          <div>
            <h1 className="text-2xl font-bold">Accès restreint</h1>
            <p className="text-red-100 text-sm">Votre compte est temporairement bloqué</p>
          </div>
        </div>

        {/* Body */}
        <div className="p-6 space-y-5">
          <p className="text-slate-700 text-base">
            Bonjour <strong>{user?.name}</strong>,
          </p>

          <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded-r-lg">
            <p className="text-red-900 font-semibold mb-2">
              ⚠️ Plusieurs prestations assignées n'ont pas été réalisées
            </p>
            <p className="text-red-800 text-sm leading-relaxed">
              Pour éviter d'autres prestations non réalisées et des soucis avec les voyageurs,
              l'accès à votre espace est <strong>temporairement restreint</strong>.
            </p>
          </div>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
            <p className="text-amber-900 font-semibold mb-2">📞 Que faire ?</p>
            <p className="text-amber-800 text-sm leading-relaxed">
              Merci de contacter <strong>l'administrateur</strong> dans les plus brefs délais pour
              régulariser votre situation et débloquer votre compte.
            </p>
          </div>

          {/* Contact */}
          <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 space-y-2">
            <p className="text-slate-700 font-semibold text-sm mb-2">Contact administrateur :</p>
            <a
              href="mailto:contact@maconciergerie-bretonne.fr"
              className="flex items-center gap-3 text-slate-700 hover:text-blue-700 transition-colors"
              data-testid="restricted-email-admin"
            >
              <Mail className="h-4 w-4 text-blue-600" />
              <span className="text-sm">contact@maconciergerie-bretonne.fr</span>
            </a>
          </div>

          {/* Logout */}
          <Button
            onClick={logout}
            variant="outline"
            className="w-full border-slate-300 hover:bg-slate-100"
            data-testid="restricted-logout-btn"
          >
            <LogOut className="h-4 w-4 mr-2" />
            Se déconnecter
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AccessRestrictedScreen;
